// Unpublished Work © 2023 Deere & Company.

import t from 'tcomb';

export const EntityLogs = t.struct({
    deceasedInd: t.String,
    jdEmployeeInd: t.String,
    legalNameVerifyDate: t.String,
    modifiedBy: t.String,
    timeStamp: t.String,
    remark: t.String
}, {
    defaultProps: {
        deceasedInd: '',
        jdEmployeeInd: '',
        legalNameVerifyDate: '',
        modifiedBy: '',
        timeStamp: '',
        remark: ''
    },
    name: 'EntityLogs',
    strict: true
});
